import airlineConfigData from './airline.config.json';

export const getAirlineName = (useShort = false) => {
    return useShort ? airlineConfigData.airline.nameShort : airlineConfigData.airline.name;
};

export const getAirlineICAO = () => airlineConfigData.airline.icaoCode;

export const formatCallsign = (number) => {
    return `${airlineConfigData.airline.icaoCode}${String(number).padStart(3, '0')}`;
};

export const isFeatureEnabled = (feature) => {
    return airlineConfigData.features[feature] === true;
};

export const getBrandColors = () => airlineConfigData.branding.colors;

export const getContactEmail = () => airlineConfigData.contact.email;

export const getSupportEmail = () => airlineConfigData.contact.supportEmail;

export const getWebsiteUrl = () => airlineConfigData.contact.website;

export const getApiUrl = () => {
    return airlineConfigData.urls.api;
};

export const getSocialLinks = () => airlineConfigData.social;

export const getSEOData = (language = 'EN') => {
    return {
        title: airlineConfigData.seo.title[language] || airlineConfigData.seo.title['EN'],
        description: airlineConfigData.seo.description[language] || airlineConfigData.seo.description['EN'],
        keywords: airlineConfigData.seo.keywords[language] || airlineConfigData.seo.keywords['EN']
    };
};

export const getSlogan = (language = 'EN') => {
    return airlineConfigData.airline.slogan[language] || airlineConfigData.airline.slogan['EN'];
};

export const getDescription = (language = 'EN') => {
    return airlineConfigData.airline.description[language] || airlineConfigData.airline.description['EN'];
};

// Export the full config for direct access if needed
export default airlineConfigData;